/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   11/11/2022
 */

import React from "react";
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";
import { EmployeeNameFormat } from "../../interfaces/Global";

export interface CapacityFormatSelectorProps {
	value: string
	setValue: (format: EmployeeNameFormat) => void
}

export default function CapacityFormatSelector(props: CapacityFormatSelectorProps) {

	return (
		<FormControl variant={"standard"}>
			<InputLabel>Capacity Format</InputLabel>
			<Select
				variant={"standard"}
				value={props.value}
				onChange={(event) => props.setValue(event.target.value as EmployeeNameFormat)}
			>
				<MenuItem value={"availability"}>Availability</MenuItem>
				<MenuItem value={"headcount"}>Headcount</MenuItem>
				<MenuItem value={"availability-headcount"}>Availability and headcount</MenuItem>
				<MenuItem value={"headcount-availability"}>Headcount and availability</MenuItem>
				<MenuItem value={"off"}>Disabled</MenuItem>
			</Select>
			<FormHelperText>Number of people in each group in the Slack message will be formatted according to this selection.</FormHelperText>
		</FormControl>
	);

}